<template>
  <BaseDialogContainer :dialogModel="dialog" title="Delete preset profile">
    <template #activatorButton="{ on: buttonOn, attrs: buttonAttrs }">
      <div class="dialog-activator-button">
        <v-btn
          icon
          small
          v-bind="buttonAttrs"
          v-on="buttonOn"
          @click="dialog = true"
        >
          <v-icon small style="color: var(--color-secondary-light)"
            >mdi-trash-can</v-icon
          >
        </v-btn>
      </div>
    </template>
    <template #icon>
      <v-icon color="primary">mdi-trash-can</v-icon>
    </template>
    <template #content>
      <p style="color: var(--color-text-muted)">
        Are you sure you want to delete this preset profile?
      </p>
      <Transition name="fade" class="ma-0">
        <div v-if="showError">
          <p class="error--text text-center pa-0 ma-0">
            {{ deleteError }}
          </p>
        </div>
      </Transition>
    </template>
    <template #primaryButton>
      <v-btn
        color="primary"
        rounded
        block
        :loading="deleteLoading"
        @click="onPrimaryButtonPressed"
      >
        Delete
      </v-btn>
    </template>
    <template #cancelButton>
      <v-btn color="primary" block rounded text @click="onCancelButtonPressed">
        Cancel
      </v-btn>
    </template>
  </BaseDialogContainer>
</template>

<script>
import BaseDialogContainer from "../../../../core/BaseDialogContainer.vue";
import { mapState } from "vuex";
export default {
  name: "DeletePresetDialog",
  components: {
    BaseDialogContainer,
  },
  data() {
    return {
      dialog: false,
      showError: false,
      errorTimeout: null,
    };
  },
  computed: {
    ...mapState("kDiagram/profiles", ["selectedProfile"]),
    ...mapState("kDiagram/profiles/deleteProfile", [
      "deleteLoading",
      "deleteError",
    ]),
  },
  methods: {
    async onPrimaryButtonPressed() {
      await this.$store.dispatch(
        "kDiagram/profiles/deleteProfile/deleteProfile",
        {
          vesselName: this.$route.params.vessel,
          profileId: this.selectedProfile.id,
        }
      );
      if (this.deleteError && !this.deleteLoading) {
        this.showError = true;
        if (this.errorTimeout) {
          clearTimeout(this.errorTimeout);
        }
        this.errorTimeout = setTimeout(() => {
          this.showError = false;
        }, 5000);
      } else {
        this.dialog = false;
        this.$store.dispatch(
          "kDiagram/profiles/fetchProfiles",
          this.$route.params.vessel
        );
        this.$store.commit("kDiagram/profiles/SET_SELECTED_PROFILE", null);
      }
    },
    onCancelButtonPressed() {
      this.dialog = false;
      this.showError = false;
      if (this.errorTimeout) {
        clearTimeout(this.errorTimeout);
      }
    },
  },
  watch: {
    deleteError: {
      handler(value) {
        if (value !== null && this.deleteLoading) {
          this.showError = true;
          if (this.errorTimeout) {
            clearTimeout(this.errorTimeout);
          }
          this.errorTimeout = setTimeout(() => {
            this.showError = false;
          }, 5000);
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
    }
  },
};
</script>

<style scoped>
.dialog-activator-button {
  background-color: var(--color-bg);
  width: fit-content;
  border-radius: 10px;
  border: 1px solid transparent;
  padding: 0 4px;
  z-index: 1;
  transition: border-color var(--transition-default);
}

.dialog-activator-button:hover {
  border-color: var(--color-secondary-light);
}
</style>
